import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  confirmPasswordReset,
  Auth,
  AuthError,
  AuthErrorCodes,
} from 'firebase/auth';

export const register = (auth: Auth, email: string, password: string) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const login = (auth: Auth, email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const logout = (auth: Auth) => {
  return auth.signOut();
};

export const forgotPassword = (auth: Auth, email: string) => {
  return sendPasswordResetEmail(auth, email);
};

export const resetPassword = (
  auth: Auth,
  oobCode: string,
  newPassword: string,
) => {
  return confirmPasswordReset(auth, oobCode, newPassword);
};

export const handleAuthError = (error: AuthError) => {
  switch (error.code) {
    case AuthErrorCodes.EMAIL_EXISTS:
      return 'Ця електронна адреса вже використовується.';
    case AuthErrorCodes.INVALID_PASSWORD:
    case AuthErrorCodes.INVALID_IDP_RESPONSE:
      return 'Невірний email або пароль.';
    case AuthErrorCodes.EXPIRED_OOB_CODE:
    case AuthErrorCodes.INVALID_OOB_CODE:
      return 'Недійсний код.';
    default:
      return 'Щось пішло не так! Спробуйте будь ласка пізніше.';
  }
};
